import { ReactElement } from "react";
import {
  OnErrorResponse,
  OnEventResponse,
  OnTrackEventResponse,
  SurveyVariantEnumType,
  ValueOf,
  WiseOwlIngress,
  WiseOwlUser,
} from "@twiliointernal/e2-commons-shared-definitions";

export const SurveyErrorVariantsEnum = {
  fetchSurveyQuestions: "fetchSurveyQuestions",
  submitSurvey: "submitSurvey",
  none: "none",
} as const;

export type SurveyErrorVariantsEnumType = ValueOf<
  typeof SurveyErrorVariantsEnum
>;

export interface ErrorState {
  error: boolean;
  type: SurveyErrorVariantsEnumType;
}

export interface SurveyProviderContextProp {
  chatId?: string;
  displayName: string;
  isChatActive: boolean;
  ingress: WiseOwlIngress;
  liveChatId?: string;
  onError?: (args: OnErrorResponse) => void;
  onEvent?: (args: OnEventResponse) => void;
  onTrackEvent?: (args: OnTrackEventResponse) => void;
  sendGridUserId?: string;
  surveyId?: string;
  surveyVariant?: SurveyVariantEnumType;
  ticketId?: number;
  user?: WiseOwlUser;
  token?: string;
}

export interface SurveyProviderProps {
  children: ReactElement;
  context: SurveyProviderContextProp;
}

export interface SurveyContextStateValues
  extends Pick<
    SurveyProviderContextProp,
    "displayName" | "ingress" | "user" | "token" | "liveChatId" | "ticketId"
  > {
  chatId: string;
  errorState: ErrorState;
  isSurveyEnabled: boolean;
  isSurveySubmitted: boolean;
  isSurveyVisible: boolean;
  submitFeedbackFailed: boolean;
  surveyId: string;
  surveyVariant: SurveyVariantEnumType;
}

export interface SurveyContextHandlers
  extends Pick<
    SurveyProviderContextProp,
    "onError" | "onEvent" | "onTrackEvent"
  > {
  handleCancelSurvey: () => void;
  handleShowSurvey: () => void;
  resetSurveyState: () => void;
  setErrorState: (errorState: ErrorState) => void;
  setSurveySubmitted: () => void;
  setSurveyNotSubmitted: () => void;
}

export interface SurveyContextProps {
  state: SurveyContextStateValues;
  handlers: SurveyContextHandlers;
}
